<template lang="pug">
  .tab
    vant-row.link(type="flex", justify="space-between", align="center")
      vant-col(span="20")
        router-link(:to="leftLink", :class="{active: active === 'left'}")
          span {{ leftText  || '--' }}
           span.border
      vant-col(span="1")
        .divide(@click="tryOpenConsole")
      vant-col(span="20")
        router-link(:to="rightLink", :class="{active: active === 'right'}")
          span {{ rightText || '--'}}
           span.border
</template>

<script>
import { Image, Row, Col } from 'vant'

export default {
  props: {
    leftText: String,
    rightText: String
  },
  components: {
    VantImg: Image,
    VantRow: Row,
    VantCol: Col
  },
  data() {
    return {
      active: 'left',
      tryCount: 0,
      startTs: 0
    }
  },
  mounted() {
    this.$router.onReady(() => {
      this.decideActive()
    })
  },
  computed: {
    rightLink() {
      return '/future-chance/list'
    },
    leftLink() {
      return '/today-hot/list'
    }
  },
  methods: {
    tryOpenConsole() {
      if (this.tryCount === 0) {
        this.startTs = new Date().getTime()
      }
      this.tryCount += 1
      if (this.tryCount === 10) {
        if (new Date().getTime() - this.startTs > 5000) {
          this.tryCount = 0
          return false
        }
        import('@utils/vconsole.min').then(c => {
          const Console = c.default
          window.vConsole = new Console()
        })
      }
    },
    decideActive() {
      if (this.$route.path.indexOf(this.rightLink) === 0) {
        this.active = 'right'
      } else {
        this.active = 'left'
      }
    }
  },
  watch: {
    $route(to, from) {
      this.decideActive()
    }
  }
}
</script>

<style lang="stylus" scoped>
.tab
  .link
    background white
    line-height 3.15rem
  & .fix
    position relative
    top -3px
  a
    display block
    text-align center
    color $normal-text-color
    font-weight 600
  .divide
    width 0
    height 2rem
    // border-right 1px solid #ccc
    position relative
    left 0.2rem
  .active
    color $theme-color !important
    >span
      position relative
      .border
        display inline-block
        position absolute
        left 50%
        top 22px
        transform translate(-50%,-50%)
        height 4px
        width 20px
        background-color $theme-color
        border-radius 4px
</style>
